module.exports = __webpack_public_path__ + "img/other02_img.acd69568.png";